import React from "react";
import Grid from "@material-ui/core/Grid";
import ColAtm from "../../../../../atomic/Col/Col";
import BlockAtm from "../../../../../atomic/Block/Block";
import OverFlowText from "../../../../../molecules/OverFlowText/OverFlowText";
import ChannelListModal from "./ChannelListModal";
import {history} from "../../../../../../utils/history";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { propertyProducts } from "../../../../../../redux/actions/propertyProductsActions";
import { isDefined } from "../../../../../../utils";

const ChannelList = (props) => {
    const {channelList} = props;

    const dispatch = useDispatch();
    const propertyProductsReducer = useSelector(state => state.propertyProductsReducer);

    useEffect(() => {
        if (!propertyProductsReducer?.get_products) {
            dispatch(propertyProducts());
        }
    }, []);

    const networkProduct = !propertyProductsReducer?.fetching &&
        isDefined(propertyProductsReducer?.get_products)
            ? Object.values(propertyProductsReducer.get_products.data).find(item => item.route === "network")
            : null;

    const showMarketBasedPricing = isDefined(networkProduct) &&
        (networkProduct.parameters?.length === 0 || networkProduct.parameters?.some(p => p?.product_parameter_id === 203 && p?.is_selected === 1));

    const handleClickOpen = (e, id) => {

        history.push(`/app/network/channel-information/${id}`)
    };

    return(
        <Grid container spacing={3}>
            {
                Object.values(channelList).map( channel => (
                    <ColAtm className="offer-fact-col pos-relative" md={2} sm={4} xs={6}>
                        {
                            (channel.has_children && channel.is_selected && showMarketBasedPricing) &&
                                <ChannelListModal channel={channel} />
                        }
                        <BlockAtm className="offer-fact-border-box fact-border-box channel-group-box" onClick={(e) => handleClickOpen(e, channel.id)}>
                            <label htmlFor={"id-" + channel.id}>
                                <label style={{position: 'relative'}}
                                       htmlFor={"id-" + channel.id}>
                                    <div style={{backgroundImage: `url(`+ channel.logoUrl +`)`}} className={channel.is_selected ? "channel-logo-bg": channel.is_pending ? "channel-logo-bg channel-grayscale-pending-box" : "channel-logo-bg channel-grayscale-box"} >
                                        <i className={channel.is_selected ? "channel-active-icon fad fa-dot-circle green" : channel.is_pending && "channel-active-icon fad fa-dot-circle blue"} />
                                    </div>
                                    <BlockAtm className={channel.is_selected ? "selected-channel-block" : "de-select-channel"}>
                                        <OverFlowText>
                                            {channel.name}
                                        </OverFlowText>
                                    </BlockAtm>
                                </label>
                            </label>
                        </BlockAtm>
                    </ColAtm>
                ))
            }
        </Grid>
    )
}
export default ChannelList;
